import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {PasswordChange} from '../models/password-change';

@Injectable({
  providedIn: 'root'
})
export class AccountSharingService {

  private changePasswordSubject = new BehaviorSubject<PasswordChange>(null);
  passwordChange = this.changePasswordSubject.asObservable();
  private changeNotificationsSubject = new BehaviorSubject<string>(null);
  notificationChange = this.changeNotificationsSubject.asObservable();

  constructor() { }

  updateChangePassword(password: PasswordChange): void {
    this.changePasswordSubject.next(password);
  }

  updateChangeNotification(change: string): void {
    this.changeNotificationsSubject.next(change);
  }
}
